import Table from "components/molecules/table/Table";
import { FC, useMemo } from "react";
import { Column } from "react-table";
import { Fragment } from "react/jsx-runtime";


export interface ISalariesTableProps<T> {
    data: T;
    dataCols: any;
    background?: string;
}

const SalariesTable: FC<ISalariesTableProps<any>> = ({ data, dataCols, background = 'solid' }) => {

    const columns = useMemo<Column<any>[]>(
        () =>

            dataCols.filter((cols: any) => cols.isChecked)

        , [dataCols]

    ) as Column<object>[];

    return (
        <Fragment>
            <Table columns={columns} data={data} search={""} isColumnSorted={true}
                classes={{ container: background === 'transparent' ? '!bg-transparent' : `` }}
            />
        </Fragment>
    );
};

export default SalariesTable;
